import { useNavigate, useLocation, useOutletContext } from 'react-router-dom'
import { nextPage } from 'components/RCPro/helpers/nav'
import PaymentCard from 'components/assets/icons/PaymentCard'
import BankTransfer from 'components/assets/icons/BankTransfer'
import Arrow from 'components/assets/icons/Arrow'
import Button from 'components/common/Button/Button'
import style from './PaymentChoice.module.scss'
import { useState } from 'react'

const RCProPaymentChoice = () => {
  const navigate = useNavigate()
  const { state, pathname } = useLocation()
  const { nextPageTransition } = useOutletContext()
  const [ paymentChoice, setPaymentChoice ] = useState(undefined)
  const { payment, layout } = state.texts

  const options = [
    {
      svg: <PaymentCard />,
      text: payment?.CB,
      name: 'CB'
    },
    {
      svg: <BankTransfer />,
      text: payment?.transfer,
      name: 'IBAN'
    }
  ]

  const submit = () => {
    nextPage({ pathname, state, navigate, data: { paymentChoice } })
    nextPageTransition()
  }

  return (
    <>
      <h1>{payment?.title}</h1>

      <ul className={style.choices}>
        {options.map( opt => (
          <li key={`option-${opt.name}`} onClick={() => setPaymentChoice(opt.name)} className={paymentChoice === opt.name ? style.active : undefined}>
            {opt.svg}
            {opt.text}
          </li>
        ) )}
      </ul>

      <Button
        label={<>{layout?.next} <Arrow /></>}
        onClick={submit}
        disabled={!paymentChoice}
        type="primary"
      />
    </>
  )
}

export default RCProPaymentChoice